import { useEffect } from "react";
import { useHelpWorkflow, useHelpWorkflowOptional } from "context/HelpWorkflowContext";

/**
 * Registers the current page workflowId for the global help modal (mirrors HelpVideoButton).
 */
export function useRegisterHelpWorkflow(workflowId) {
  const { setWorkflowId } = useHelpWorkflow();

  useEffect(() => {
    if (!workflowId) return undefined;
    setWorkflowId(workflowId);
    return () => setWorkflowId(null);
  }, [workflowId, setWorkflowId]);
}

/**
 * Attaches page-specific help topics to the global ? menu.
 * Safe when the help provider is absent (unit tests that render a page alone).
 *
 * @param {{ workflowId?: string, topics?: { id: string, title: string, bodyText: string }[] }} options
 */
export function useRegisterPageHelp({ workflowId, topics } = {}) {
  const ctx = useHelpWorkflowOptional();
  const setWorkflowId = ctx?.setWorkflowId;
  const setPageTopics = ctx?.setPageTopics;

  useEffect(() => {
    if (!setWorkflowId && !setPageTopics) return undefined;
    if (workflowId) setWorkflowId(workflowId);
    if (topics) setPageTopics(topics);
    return () => {
      if (workflowId) setWorkflowId?.(null);
      setPageTopics?.([]);
    };
  }, [workflowId, topics, setWorkflowId, setPageTopics]);
}
